<template>
  <a
    :class="linkKls"
    :href="disabled || !href ? undefined : href"
    @click="handleClick"
  >
    <sg-icon v-if="icon"><component :is="icon" /></sg-icon>
    <span v-if="$slots.default" :class="ns.m('inner')">
      <slot></slot>
    </span>

    <slot v-if="$slots.icon" name="icon"></slot>
  </a>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'
import { SgIcon } from '@sgui-plus/components/icon'
import { useNamespace } from '@sgui-plus/hooks'
import { linkProps, linkEmits } from './link'

export default defineComponent({
  name: 'SgLink',

  components: { SgIcon },

  props: linkProps,
  emits: linkEmits,

  setup(props, { emit }) {
    const ns = useNamespace('link')

    const linkKls = computed(() => [
      ns.b(),
      ns.m(props.type),
      ns.is('disabled', props.disabled),
      ns.is('underline', props.underline && !props.disabled),
    ])

    function handleClick(event: MouseEvent) {
      if (!props.disabled) emit('click', event)
    }

    return {
      ns,
      handleClick,
      linkKls
    }
  }
})
</script>
